export default __webpack_public_path__ + "static/media/icon-instagram.72a75b33.svg";